// Konusma gecmisi mesajlarini ChatHistoryDetail formatina cevirir.
// ChatHistoryListTwo.vue ile MessagesView.vue arasinda paylasilir.
const _ = require("lodash");

function convertHistoryMessages(items, formatHour) {
    const allMessages = items
        .map((x, i) => {
            let type = "";
            let author = "";
            if (x.messageType === "system") {
                type = "system";
            } else if (["user", "chatbot"].includes(x.messageType)) {
                type = "text";
                author = x.userId || "Chatbot";
            } else if (x.messageType.includes("chatbot")) {
                type = x.messageType;
                author = "Chatbot";
            } else if (x.messageType === "private") {
                type = "private";
            } else if (x.messageType === "visitor") {
                type = "text";
                author = "me";
            } else if (x.messageType === "user-media" || x.messageType === "visitor-media") {
                author = x.messageType === "user-media" ? x.userId : "me";
                if ((!!x.asset.mime && x.asset.mime.includes("image")) || ["jpg", "jpeg", "png"].includes(x.asset.ext)) {
                    type = "image";
                } else if ((!!x.asset.mime && x.asset.mime.includes("audio")) || x.asset.ext.includes("mp3")) {
                    type = "audio";
                } else {
                    type = "asset";
                }
            } else if (x.messageType === "visitor-location") {
                author = x.messageType === "visitor-location" ? "me" : x.userId;
                type = "location";
            } else if (x.messageType === "user-location") {
                author = x.messageType === "user-location" ? x.userId : "me";
                type = "location";
            } else if (x.messageType.startsWith("chatbot")) {
                type = x.messageType;
                author = "chatbot";
            }
            return {
                type,
                author,
                data: {
                    text: x.message || x.description || _.get(x, "payload.text"),
                    meta: formatHour(x.createdDate),
                },
                raw: x,
            };
        })
        .filter((x) => x !== undefined);
    return allMessages;
}

module.exports = { convertHistoryMessages };



// WEBPACK FOOTER //
// ./src/utils/convertHistoryMessages.js